import React from 'react';
export const InviteUserPageOnLoading = () => {
	return (
		<div className='loader-accounts'>
			<div className='loader' />
		</div>
	);
};
